(() => {
  function init(root = document) {
    root.querySelectorAll('.gsp__trust-strip:not([data-marquee])').forEach(strip => {
      strip.dataset.marquee = 'true';
      strip.removeAttribute('role');
      const group = document.createElement('div');
      group.className = 'gsp-trust-group';
      group.setAttribute('role', 'list');
      group.setAttribute('aria-label', 'Services Gourde-iso');
      while (strip.firstChild) group.append(strip.firstChild);
      const track = document.createElement('div');
      track.className = 'gsp-trust-track';
      track.append(group);
      const clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.inert = true;
      track.append(clone);
      const viewport = document.createElement('div');
      viewport.className = 'gsp-trust-viewport';
      viewport.append(track);
      strip.append(viewport);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
